export default "__VITE_ASSET__b7d8603b__"